import 'angular-gettext';
import contactsTags, { ContactsTagsService } from '../../../../contacts/sidebar/filter/tags/tags.service';
import importCsv, { ImportCsvService } from '../csv.service';
import modal, { ModalService } from '../../../../common/modal/modal.service';
import serverConstants, { ServerConstantsService } from '../../../../common/serverConstants/serverConstants.service';

class PreviewController {
    accept: boolean;
    appName: string = process.env.APP_NAME;
    watcher: () => void;
    constructor(
        $rootScope: ng.IRootScopeService,
        private gettextCatalog: ng.gettext.gettextCatalog,
        private contactsTags: ContactsTagsService,
        private importCsv: ImportCsvService,
        private modal: ModalService,
        private serverConstants: ServerConstantsService, // used in view
    ) {
        this.accept = false;

        this.watcher = $rootScope.$on('accountListUpdated', () => {
            this.contactsTags.load();
        });
    }
    $onInit(): void {
        this.contactsTags.load();
    }
    $onDestroy(): void {
        this.watcher();
    }
    save(): ng.IPromise<any> {
        this.importCsv.data.in_preview = false;
        return this.importCsv.save().then(() => {
            this.importCsv.data = null;
            const message = this.gettextCatalog.getString(
                'Your CSV import has started and your contacts will be in {{app_name}} shortly. We will email you when your import is complete.',
                {
                    app_name: process.env.APP_NAME,
                },
            );
            return this.modal.info(message);
        });
    }
    back(): void {
        this.importCsv.back();
    }
}

const Preview: ng.IComponentOptions = {
    controller: PreviewController,
    template: require('./preview.html'),
};

export default angular
    .module('mpdx.tools.import.csv.preview.component', ['gettext', contactsTags, importCsv, modal, serverConstants])
    .component('importCsvPreview', Preview).name;
